import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { installConsoleShipper } from './lib/consoleShipper';
import './styles.css';

if (import.meta.env.DEV) installConsoleShipper();

// 去掉 React.StrictMode —— dev 环境下会双重挂载 useEffect,导致 useRTC 先 join 再 leave 卡在 'left' 状态
ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
